export const THEME_IDS = ['quizheroes', 'ocean'] as const;

export type ThemeId = (typeof THEME_IDS)[number];

export const DEFAULT_THEME_ID: ThemeId = 'quizheroes';

export function resolveThemeId(value: unknown): ThemeId {
  if (typeof value === 'string' && (THEME_IDS as readonly string[]).includes(value)) {
    return value as ThemeId;
  }

  return DEFAULT_THEME_ID;
}

export function isThemeId(value: string): value is ThemeId {
  return (THEME_IDS as readonly string[]).includes(value);
}
